var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTutorialsAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 27.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bdccd4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-tutorials-account") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.05,0H13.65a.93.93,0,0,0-.95.95V9.78a1.67,1.67,0,0,0,.38,0,3.09,3.09,0,0,1,0,6.18h-.35V26.38a.93.93,0,0,0,.95.95h15.4a.93.93,0,0,0,.95-.95V.92A.92.92,0,0,0,29.05,0Zm-.92,25.4H17.41l6-1.48a1,1,0,0,0,.76-.95V4.35a1,1,0,0,0-.76-.95l-6-1.51H28.14ZM20.66,13.63a.95.95,0,0,1,1.89,0,.93.93,0,0,1-.95.95A1,1,0,0,1,20.66,13.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.38,11.68a4.45,4.45,0,0,0,.6.95,6.13,6.13,0,0,0,4.1,1.48,1.23,1.23,0,0,0,1.23-1.23,1.25,1.25,0,0,0-1.2-1.23,3.91,3.91,0,0,1-2.34-.73c-.06-.09-.25-.47-.38-.73C9.87,9.06,9,7.38,7.38,7.38H4.44c-2,0-2.78,2.11-3.22,3.25A4.39,4.39,0,0,0,1,11,34.45,34.45,0,0,0,0,15,1.2,1.2,0,0,0,1,16.38a.62.62,0,0,0,.22,0,1.24,1.24,0,0,0,1.2-1A31.1,31.1,0,0,1,3.24,12c0-.06,0-.13.06-.16l.09,3.91L2.26,25.84A1.28,1.28,0,0,0,3.4,27.26h.16a1.27,1.27,0,0,0,1.26-1.14l1-9.18,1.07,9.18a1.29,1.29,0,0,0,2.56-.28L8.32,15.71Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 5.86,
    cy: 4.2,
    r: 2.56
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTutorialsAccount);
export default __webpack_public_path__ + "static/media/icon-tutorials-account.2cd422d3bc3cd37e56d76c5c805444bc.svg";
export { ForwardRef as ReactComponent };